import { classnames } from '@/helpers';

const VARIANT = {
  symbol: 'symbol',
  wordmark: 'wordmark',
  'wordmark-dark': 'wordmark-dark',
  logo: 'logo',
  'logo-dark': 'logo-dark',
} as const;

type Variant = (typeof VARIANT)[keyof typeof VARIANT];

export type LogotypeProps = {
  variant: Variant;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
} & React.HTMLAttributes<HTMLImageElement>;

const Logotype = ({ variant, className = '', ...props }: LogotypeProps) => {
  return (
    <img
      src={`/images/logotypes/${variant}.svg`}
      {...props}
      className={classnames(className)}
      alt={props?.alt ?? 'Bokadirekt'}
    />
  );
};

export default Logotype;
